import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-staff',
  templateUrl: './helpbutton-staff.component.html',
  styleUrls: ['./helpbutton-staff.component.scss']
})
export class HelpbuttonStaffComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
